import PropTypes from 'prop-types';
import { memo } from 'react';
import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import H6 from '@base/H6/H6';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const Title = styled(H4)`
  color: var(--color-text-primary);
  margin-bottom: ${Spacings.SPACING_2B};
  padding: 0;
  grid-column: span 18;
`;

const SeeMoreButton = styled.div`
  grid-column: span 18;
  text-align: center;
  padding: ${Spacings.SPACING_6B};
  box-shadow: ${boxShadowGenerator({ color: 'var(--color-shadow)' })};
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-base-1);
  cursor: pointer;
`;

const PaginatedContainer = ({ feedBlock, loadMore, title, _renderItem }) => {
  return (
    <>
      <Title>{title}</Title>
      {feedBlock.results.map((courseData, index) =>
        _renderItem(courseData, index)
      )}
      {feedBlock.next && (
        <SeeMoreButton onClick={loadMore}>
          <H6 color="var(--color-text-primary)">+ See more</H6>
        </SeeMoreButton>
      )}
    </>
  );
};

PaginatedContainer.propTypes = {
  feedBlock: PropTypes.objectOf(PropTypes.any).isRequired,
  loadMore: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  _renderItem: PropTypes.func.isRequired
};

const MemoizedPaginatedContainer = memo(PaginatedContainer);

export default MemoizedPaginatedContainer;
